const initialStateMessage = {
    message: "Default Message"
};

export default initialStateMessage;